import { useState } from "react";
import { session } from "../api";
import { passkeysSupported, signInWithPasskey } from "../auth/passkeys";
import { errorText } from "../problem";

export function SignInPage() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const supported = passkeysSupported();

  async function signIn() {
    setBusy(true);
    setError(null);
    try {
      await session.signIn(await signInWithPasskey());
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="card-page">
      <section className="card">
        <h1>
          ten20 <span className="brand-sub">admin</span>
        </h1>
        <p>Sign in with your admin passkey.</p>
        {supported ? (
          <button type="button" onClick={() => void signIn()} disabled={busy}>
            {busy ? "Waiting for your passkey…" : "Sign in with a passkey"}
          </button>
        ) : (
          <p className="error">This browser doesn't support passkeys.</p>
        )}
        {error && (
          <p className="error" role="alert">
            {error}
          </p>
        )}
        <p className="muted">
          No admin passkey yet? Open the enrolment link an owner made for you. Your app passkeys don't work here.
        </p>
      </section>
    </main>
  );
}
